export class ConfirmationModal{ 
    
    headerMessage:string;
    bodyMessage:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/reference-document/entities/confirmation-modal.ts